interface AuthenticationResult {
    AccessToken: string;
    ExpiresIn: number;
    IdToken: string;
    RefreshToken: string;
    TokenType: string;
}

export interface User {
    auth_time: string;
    'cognito:groups': string[];
    'cognito:username': string;
    email: string;
    name: string;
}

class StorageHelper {
    private static provider: string = 'CognitoIdentityServiceProvider'
    private static instance: StorageHelper;
    private static USER_ATTRIBUTES_TO_REMOVE = ['aud', 'cognito:roles', 'email_verified', 'event_id', 'exp', 'iat', 'iss', 'jti', 'origin_jti', 'sub', 'token_use']
    private localStorage = window.localStorage;
    private authenticationResult: AuthenticationResult | undefined;

    private constructor() {
    }

    public static getInstance(): StorageHelper {
        if (!StorageHelper.instance) {
            StorageHelper.instance = new StorageHelper();
        }
        return StorageHelper.instance;
    }

    private static parse(token: string): User {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }

    configure(authResult: AuthenticationResult) {
        this.authenticationResult = authResult;
        this.cache();
    }

    getAccessToken() {
        return this.localStorage.getItem(`${StorageHelper.provider}.accessToken`)
    }

    getRefreshToken() {
        return this.localStorage.getItem(`${StorageHelper.provider}.refreshToken`)
    }

    getIdToken() {
        return this.localStorage.getItem(`${StorageHelper.provider}.idToken`)
    }

    getUser(): User {
        const userData = this.localStorage.getItem(`${StorageHelper.provider}.userData`)
        return JSON.parse(userData!)
    }

    private cache() {
        const sanitizedUserData = this.sanitizeObject(StorageHelper.parse(this.authenticationResult!.IdToken), StorageHelper.USER_ATTRIBUTES_TO_REMOVE)
        this.localStorage.setItem(`${StorageHelper.provider}.idToken`, this.authenticationResult!.IdToken)
        this.localStorage.setItem(`${StorageHelper.provider}.accessToken`, this.authenticationResult!.AccessToken)
        this.localStorage.setItem(`${StorageHelper.provider}.refreshToken`, this.authenticationResult!.RefreshToken)
        this.localStorage.setItem(`${StorageHelper.provider}.userData`, JSON.stringify(sanitizedUserData))
    }

    update(idToken: string, accessToken: string) {
        this.localStorage.setItem(`${StorageHelper.provider}.idToken`, idToken)
        this.localStorage.setItem(`${StorageHelper.provider}.accessToken`, accessToken)
    }

    clear() {
        this.localStorage.removeItem(`${StorageHelper.provider}.idToken`)
        this.localStorage.removeItem(`${StorageHelper.provider}.accessToken`)
        this.localStorage.removeItem(`${StorageHelper.provider}.refreshToken`)
        this.localStorage.removeItem(`${StorageHelper.provider}.userData`)
    }

    private sanitizeObject(obj: {}, attributes: string[]) {
        const deepCopy = JSON.parse(JSON.stringify(obj))
        attributes.map((attribute) => delete deepCopy[attribute])
        return JSON.parse(JSON.stringify(deepCopy))
    }
}


const Storage = StorageHelper.getInstance();

export default Storage;
